/** QC Test Ageing Status Report, on the QC side (user, 2026-10-13: "QC ageing back in QC"). */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { QcAgeingPage } from "@/features/quality/components/qc-ageing-page";

const search = z.object({
  asOn: z.string().optional(),
  stage: z.enum(["raw", "condition"]).optional(),
  cropId: z.coerce.number().int().positive().optional(),
  varietyId: z.coerce.number().int().positive().optional(),
  duration: z.enum(["select", "fill"]).optional(),
  preset: z.enum(["all", "lt45", "45to90", "gt90"]).optional(),
  fill: z.enum(["lt", "eq", "gt"]).optional(),
  days: z.coerce.number().int().min(0).max(3650).optional(),
});

export const Route = createFileRoute("/_app/quality/qc-ageing/")({
  validateSearch: search,
  beforeLoad: () => {
    // The report's own tick under Roles → Reports alone (user, 2026-10-29).
    const { can } = useAuth.getState();
    if (!can("processing.reports.qc_ageing")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <QcAgeingPage
      facilityId={selected?.id}
      plantName={selected?.name ?? null}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
